"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _store = require("../../redux/store");
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _CurrentPlan = _interopRequireDefault(require("../../components/CurrentPlan"));
var _SubscriptionSwitchesList = _interopRequireDefault(require("../../components/SubscriptionSwitchesList"));
var _GracePeriodError = _interopRequireDefault(require("../../components/GracePeriodError"));
var _PlanDetailsPopupManager = _interopRequireDefault(require("../../components/PlanDetailsPopupManager"));
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _popupSlice = require("../../redux/popupSlice");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _offersSlice = require("../../redux/offersSlice");
var _PlanDetailsStyled = require("./PlanDetailsStyled");
var _jsxRuntime = require("react/jsx-runtime");
const PlanDetails = _ref => {
  let {
    customCancellationReasons,
    skipAvailableDowngradesStep,
    skipAvailableFreeExtensionStep,
    displayGracePeriodError
  } = _ref;
  const {
    data: currentPlan
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectCurrentPlan);
  const {
    offerToSwitch: {
      offerId: offerToSwitchId
    }
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectPlanDetails);
  const {
    updateList: updateListValue
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectPlanDetails);
  const {
    isOpen: isPopupOpen
  } = (0, _store.useAppSelector)(_popupSlice.selectPopupDetails);
  const {
    offers
  } = (0, _store.useAppSelector)(state => state.offers);
  const {
    pauseOffersIDs
  } = (0, _store.useAppSelector)(store => store.offers);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const didMount = (0, _react.useRef)(false);
  const dispatch = (0, _store.useAppDispatch)();
  const getAndSaveSwitchSettings = async customerSubscriptions => {
    if (customerSubscriptions.length > 1) {
      dispatch((0, _planDetailsSlice.resetOfferToSwitch)());
    }
    dispatch((0, _planDetailsSlice.fetchAvailableSwitches)(customerSubscriptions));
  };
  const fetchSubscriptions = async () => {
    const customerOffers = await dispatch((0, _planDetailsSlice.fetchCustomerOffers)()).unwrap();
    const activeSubscriptions = customerOffers.filter(offer => offer.status === 'active' && offer.offerType === 'S');
    const offersWithPendingSwitches = activeSubscriptions.filter(sub => sub.pendingSwitchId);
    dispatch((0, _planDetailsSlice.fetchPendingSwitches)(offersWithPendingSwitches));
    if (activeSubscriptions.length === 1) {
      dispatch((0, _planDetailsSlice.setOfferToSwitch)(activeSubscriptions[0]));
    }
    if (activeSubscriptions.length > 0) {
      getAndSaveSwitchSettings(activeSubscriptions);
    }
  };
  (0, _react.useEffect)(() => {
    if (currentPlan.length === 0) {
      fetchSubscriptions();
    }
    if (displayGracePeriodError !== null) {
      dispatch((0, _publisherConfigSlice.init)({
        displayGracePeriodError
      }));
    }
    if (offers.length === 0) dispatch((0, _offersSlice.fetchOffers)());
    if (isPopupOpen) {
      dispatch((0, _popupSlice.hidePopup)());
      dispatch((0, _planDetailsSlice.updateList)());
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (didMount.current) {
      fetchSubscriptions();
    } else {
      didMount.current = true;
    }
  }, [updateListValue]);
  const activeSubscriptions = currentPlan.filter(offer => offer.status === 'active' && offer.offerType === 'S');
  const isPauseActive = pauseOffersIDs.includes(offerToSwitchId);
  if (isPopupOpen) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlanDetailsPopupManager.default, {
    customCancellationReasons: customCancellationReasons,
    skipAvailableDowngradesStep: skipAvailableDowngradesStep,
    skipAvailableFreeExtensionStep: skipAvailableFreeExtensionStep
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PlanDetailsStyled.WrapStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GracePeriodError.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: t('plandetails.current-plan', 'Current Plan')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlan.default, {}), activeSubscriptions.length !== 0 && !isPauseActive && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t('plandetails.change-plan', 'Change Plan')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionSwitchesList.default, {})]
    })]
  });
};
var _default = exports.default = PlanDetails;